<template>
  <div>
    <!-- Quote Edit Form -->
    <div id="quote-edit">
      <service-orders-edit-header ref="headerDetails" @header-validation="isValidHeader = !($event)" />
        <section class="quotes--quote-summary">
          <b-card class="quotes-summary">
            <line-info :detailObj="serviceOrderLine" @refresh="onRefresh" />
            <b-button variant="primary" size="sm" v-if="isCanReceive" @click="$bvModal.show('work-order-receiving-modal')" :disabled="isTransferring">
              <i v-show="isTransferring" class="fa fa-spinner fa-pulse fa-fw"></i>
              Receive Items
            </b-button>
            
            <b-button variant="primary" size="sm" v-else-if="serviceOrderLine.statusId == 1489" @click="onRelease" :disabled="isTransferring">
              <i v-show="isTransferring" class="fa fa-spinner fa-pulse fa-fw"></i>
              Release
            </b-button>
            <hr/>
            <add-edit-line-item ref="lineItems" :serviceOrderId="serviceOrderId" @onRefresh="onRefresh"></add-edit-line-item>
          </b-card>
        </section>
      <pick-list-modal
          isReceiving
          :pickTicketList="pickTicketLinesByServiceOrderLine"
          :modalId="'work-order-receiving-modal'"
          :serviceOrderId="serviceOrderId" 
          @refreshData="onRefresh" />

      <tabs :serviceOrder="serviceorder" @on-refresh="onRefresh" @credit-applied="onSaveToQbo" />
      <div class="d-flex justify-content-between mt-2">
        <div></div>
        <div class="mr-3">
          <b-button
            v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)"
            type="button"
            variant="secondary"
            size="sm"
            @click="onExit()"
          >Exit</b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_WORK_ORDER) && isQboActive"
            :variant="serviceorder.qbTxnID ? 'success' : 'primary'"
            type="submit"
            class="ml-2"
            size="sm"
            :disabled="isSaving || !serviceorder.isAuthorized"
            @click="onSaveToQbo"
          ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
          {{ serviceorder.qbTxnId == null ? 'Publish' : 'Sync' }} to Quickbooks</b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_WORK_ORDER)"
            variant="primary"
            type="submit"
            class="ml-2"
            size="sm"
            :disabled="isSaving"
            @click="onSave(false)"
          ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Continue</b-button>
          <b-button
            v-if="checkClaim(CAN_EDIT_WORK_ORDER) && checkClaim(CAN_VIEW_ALL_WORK_ORDERS)"
            variant="primary"
            type="submit"
            class=" ml-2"
            size="sm"
            :disabled="isSaving"
            @click="onSave(true)"
          ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save and Exit</b-button>
          <b-button
            v-if="checkClaim(CAN_AUTHORIZE_WORK_ORDERS)"
            :variant="serviceorder.isAuthorized ? 'success' : 'danger'"
            class="ml-2"
            size="sm"
            :disabled="isSaving"
            @click="onAuthorize"
          >
            <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
            {{ serviceorder.isAuthorized ? 'Unauthorize' : 'Authorize' }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="onEmailService"
            class="ml-2"
            :disabled="!serviceorder.isAuthorized"
          >
            <i v-show="isEmailLoading" class="fa fa-spinner fa-pulse fa-fw"></i> Send Email
          </b-button>
          <send-emails :sendEmailData="sendEmailData"></send-emails>
          <!-- <b-button
            variant="primary"
            size="sm"
            class="ml-2"
            :disabled="!serviceorder.isAuthorized"
            @click="$bvModal.show('view-fast-report')"
          >
            Print
          </b-button> -->
        </div>
      </div>
    </div>

    <!-- <report-viewer :reportName="'ServiceOrder'" :parameter="{ ServiceOrder: serviceOrderId }" /> -->
    <!-- <fast-report-viewer :parameter="serviceOrderId" :moduleName="'ServiceOrders'" /> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ServiceOrderLines from './../ServiceOrderLines';
import ServiceOrderLinesWithItems from './../ServiceOrderLinesWithItems';
import ServiceOrdersEditHeader from './components/ServiceOrdersEditHeader';
import Tabs from './components/Tabs'
import AddItem from '../ServiceOrderLines/add'
/*import reportApi from '@/resources/reportApi';*/
import SendEmails from '@/shared/components/SendEmails/index';
import ReportViewer from '@/shared/components/ReportViewer';
import FastReportViewer from '@/shared/components/FastReportViewer';
import LineInfo from './components/ServiceOrderLineInfo';
import PickListModal from '@/pages/ShippingReceiving/components/WorkOrdersTab/components/PickList';
import AddEditLineItem from '../ServiceOrderLineItems/index'

import {REPORTS_CONSTANTS} from '@/shared/constants';

export default {
  metaInfo() {
    return {
      title: `Work Order: ${this.serviceOrderId} - ${this.serviceorder.companyName}`,
    }
  },
  components: {
    ServiceOrderLines,
    ServiceOrdersEditHeader,
    Tabs,
    SendEmails,
    AddItem,
    ReportViewer,
    FastReportViewer,
    ServiceOrderLinesWithItems,
    LineInfo,
    AddEditLineItem,
    PickListModal
  },
  data() {
    return {
      reportSelectionOptions: [
        { text: 'Work Order' },
        { text: 'CC Authorization' },
        { text: 'End User Form' },
        { text: 'NCNR' },
        { text: 'Proforma Invoice' },
        { text: 'Order Confirmation' },
      ],
      checkedRowItemIds: [],
      checkedQuoteReports: [],
      isPrintLoading: false,
      isEmailLoading: false,
      sendEmailData:{},
      isSaving: false,
      isTransferring: false,
      modalId: 'add-edit-service-order-line-item-form-modal',
      selectedLineObj: {},
      isValidHeader: false
    };
  },
  computed: {
    ...mapGetters('lookup', [
      'printComments',
    ]),
    ...mapState('serviceOrders', [
      'serviceorder',
    ]),
    ...mapGetters('serviceOrderLines', ['serviceOrderLinesById', 'serviceOrderLine', 'serviceOrderLines']),
    ...mapGetters('pickTicket', ['pickTicketLinesByServiceOrderLine']),
    ...mapGetters('quickBooks', ['qboSettingState']),
    serviceOrderId() {
      return this.$route.params.id;
    },
    isCanReceive() {
      // If status of service order line is passed
      return this.serviceOrderLine.statusId == 1488 && this.serviceorder.statusId != 1494 && this.serviceorder.dateReceived == null;
    },
    isFailed() {
      // If status of service order line is failed.
      return this.serviceOrderLine.statusId == 1489;
    },
    reportOption() {
      return REPORTS_CONSTANTS.filter(x => x.module == 'ServiceOrders');
    },
    isQboActive() {
      return this.qboSettingState && this.qboSettingState.value == "1";
    }
  },
  methods: {
    ...mapActions('serviceOrders', [
      'updateServiceOrder',
      'getById',
      'authoriseServiceOrder',
      'readyToShip',
      'saveToQuickbooks'
    ]),
    ...mapActions('serviceOrderLines', ['getByServiceOrderId']),
    ...mapActions('inventory', ['releaseByPurchaseOrderLine']),
    selectedLine(line) {
      this.selectedLineObj = line;
    },
    async onSave(exit, isAuthorize = false) {
      await this.$refs.headerDetails.getHeaderValidation();
      if (this.isValidHeader) {
        try {
          this.isSaving = true;
          await this.updateServiceOrder({body: this.serviceorder, isAuthorize}).then(() => this.onSaveToQbo());
          this.isSaving = false;
          if (exit) {
            this.onExit();
          }
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      }
    },
    onExit(){
      this.$router.push({ name: 'serviceorders' });
    },

    async onAuthorize() {
      if (this.serviceorder.isAuthorized) {
        await this.onSave(false, !this.serviceorder.isAuthorized);
      } else {
        await this.$refs.headerDetails.getHeaderValidation();
        if (this.isValidHeader) {
          await this.onSave(false, !this.serviceorder.isAuthorized);
        }
      }
    },
    onShowEdit(serviceOrderLine) {
    },
    onRowClick(e) {
      this.selectedSO = e;
    },
    async onRefresh() {
      await this.onSave(false);
      this.getById(this.serviceOrderId);
      this.getByServiceOrderId(this.serviceOrderId)
      this.componentKey += 1;
    },
    async onEmailService() {
      //this.isEmailLoading = true;
      //subject:`Service Order: ${this.serviceOrderId} - ${this.serviceorder.companyName}`,
      this.sendEmailData = {template: 'WO', source:'Service Order',to:this.serviceorder.contactEmail,ReferenceId:this.serviceOrderId, reportSelectionOptions: this.reportOption}
      this.$root.$emit('bv::show::modal', 'send-email-modal');
      //this.isEmailLoading = false;
    },
    async onReadyToShip() {
      this.isTransferring = true;
      const response = await this.readyToShip(this.serviceOrderLine.id).catch(() => this.isTransferring = false);
      this.isTransferring = false;
      if (response.status == 200){
        this.$snotify.success('Successfully transferred');
        this.$router.push({
          name: 'salesorders.edit',
          params: {id: this.serviceOrderLine.salesOrderId}
        })
      }
    },
    async onRelease() {
      this.isTransferring = true;
      const response = await this.releaseByPurchaseOrderLine({
        poLineId: this.serviceOrderLine.purchaseOrderLineId,
        soLineId: this.serviceOrderLine.salesOrderLineId
      }).catch(() => this.isTransferring = false);
      this.isTransferring = false;
      if (response.status == 200){
        this.$snotify.success('Successfully released');
        this.$router.push({
          name: 'salesorders.edit',
          params: {id: this.serviceOrderLine.salesOrderId}
        })
      }
    },
    async onSaveToQbo() {
      try {
        if (this.isQboActive) {
          this.isSaving = true;
          const result = await this.saveToQuickbooks(this.serviceOrderId);

          if (result.status == 200) {
            this.$snotify.success('Successfully saved to Quickbooks');
          }
          this.isSaving = false;  
        }       
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
  },
  watch: {
  },
  async mounted() {
    if (this.serviceOrderId) {
      this.getByServiceOrderId(this.serviceOrderId).then(()=> {
        this.$refs.lineItems.onLoadServiceOrderLine();
      });
    }
  },
};
</script>
